import { Box, Typography } from '@mui/material';
import chevronTop from 'assets/images/chevronTop.svg';
import { ReactNode, useState } from 'react';

export const Accordion = ({
  title,
  children,
  index,
}: {
  index: number;
  title: string;
  children: ReactNode;
}) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Box
      borderBottom="0.6px solid #008B5E"
      // px={4}
      // pt={4}
      bgcolor={expanded ? '#fff' : '#F5FFFC'}
      pb="27px"
      sx={{
        px: {
          xs: 2,
          md: 4,
        },
        pt: {
          xs: 3,
          md: 4,
        },
      }}
    >
      <Box sx={{ transition: 'height 1s ease-in' }} height="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            component="h2"
            fontWeight={600}
            color="#008B5E"
            fontSize={20}
            lineHeight="24px"
            sx={{ cursor: 'pointer' }}
            onClick={() => setExpanded((s) => !s)}
          >
            <Typography
              component="span"
              width={index > 8 ? 26 : 18}
              fontSize={20}
              fontWeight={600}
              lineHeight="24px"
              display="inline-block"
            >
              {index + 1}.
            </Typography>{' '}
            {title}
          </Typography>
          <Box
            alignSelf="flex-start"
            sx={{
              cursor: 'pointer',
              userSelect: 'none',
              '& img': {
                transform: `scale(1,${expanded ? 1 : -1})`,
                transition: 'transform .1s linear',
              },
            }}
            flexShrink={0}
            height={32}
            width={32}
            border="1px solid rgba(30, 56, 65, 0.26)"
            display="flex"
            justifyContent="center"
            alignItems="center"
            onClick={() => setExpanded((s) => !s)}
          >
            <img src={chevronTop.src} alt="expand icon" />
          </Box>
        </Box>
        <Typography
          // mt="20px"
          fontSize={18}
          letterSpacing="0.01em"
          lineHeight="29px"
          color="rgba(0, 0, 0, 0.6)"
          // pl="20px"
          // display={expanded ? 'inherit' : 'none'}
          // visibility={expanded ? 'visible' : 'hidden'}
          sx={{
            transition: 'max-height .2s ease-out, margin .2s ease-out',
            maxHeight: expanded ? 500 : 0,
            overflow: 'hidden',
            opacity: expanded ? 1 : 0,
            mt: expanded ? '20px' : 0,
            pl: { xs: 0, md: index > 8 ? '28px' : '22px' },
            '& a': {
              color: '#FF6446',
              textDecoration: 'underline',
            },
            '& br': {
              marginTop: 1.5,
              display: 'block',
              content: "' '",
            },
            '& ol': {
              listStyleType: 'lower-alpha',
            },
          }}
        >
          {children}
        </Typography>
      </Box>
    </Box>
  );
};
